import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';
import api from '~/services/api';

function FullScreenLayout({ children }) {
  const [jwtToken, setJwtToken] = useState(null);
  const [ativo, setAtivo] = useState(false);

  useEffect(() => {
    if (window.opener) {
      // 1. Envia um "ping" para a janela de origem avisando que est� pronta
      window.opener.postMessage({ type: 'READY' }, window.location.origin);
    }

    // 2. Aguarda o jwtToken
    const handleMessage = (event) => {
      // Ensure security: check the origin
      if (event.origin !== window.location.origin) return;

      if (event.data.auth) {
        const { token } = event.data.auth;
        api.defaults.headers.token = token;
        api.defaults.headers.Authorization = `Bearer ${token}`;
        api.defaults.headers.common.Authorization = `Bearer ${token}`;

        setJwtToken(token);
        setAtivo(true); // So monta a tela apos receber o jwtToken
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // Implements refresh token
  useEffect(() => {
    if (!ativo) {
      return;
    }

    const renewToken = async () => {
      try {
        const { data } = await api.post('logins/refresh', {
          token: jwtToken,
        });

        api.defaults.headers.token = data;
        api.defaults.headers.Authorization = `Bearer ${data}`;
        api.defaults.headers.common.Authorization = `Bearer ${data}`;

        setJwtToken(data);
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      }
    };

    renewToken();

    const isTime = setInterval(() => {
      renewToken();
    }, 120000);

    return () => clearInterval(isTime);
  }, [ativo]);

  return <>{ativo && children}</>;
}

FullScreenLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default FullScreenLayout;
